import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutReplaceUserResultModal extends Layout {
    labelFail: Label;
    labelFailCount: Label;
    labelFailPipe: Label;
    labelStatus: Label;
    labelSuccess: Label;
    labelSuccessCount: Label;
    labelViewFailed: Label;
    panelFailure: Panel;
    panelSuccess: Panel;
}
